import React from 'react';

export const useCurrentDate = () => {
  const [currentDate] = React.useState(() => new Date());

  return currentDate;
};
